import script from "./AddQuestionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddQuestionPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__